<mat-toolbar class="topbar">

  <app-branding></app-branding>
  
  <button mat-icon-button (click)="toggleMobileNav.emit()" *ngIf="!showToggle"  [matTooltip]="'BUTTON.xxx' | translate">
    <i-tabler name="menu-2" class="icon-20 d-flex"></i-tabler>
  </button>
  <!--
  <button mat-icon-button aria-label="Notifications">
    <i-tabler class="d-flex" name="bell" matBadge="1" matBadgeColor="primary"></i-tabler>
  </button>
  -->
  
  <span class="flex-1-auto"></span>

  <span *ngIf="user" class="d-flex align-items-center"> 
    <span class="mat-body-2 " style="margin-bottom: 0px !important;">{{user.email}}</span>
    <button mat-icon-button [matMenuTriggerFor]="profilemenu" aria-label="Notifications" class="d-flex align-items-center">
      <!--
      <img src="/assets/images/profile/user-1.jpg" class="rounded-circle object-cover" width="35" />
      -->
      <mat-icon class="d-flex align-items-center">
        <i-tabler name="user" class="icon-23 d-flex"></i-tabler></mat-icon>
    </button>
    <mat-menu #profilemenu="matMenu" class="topbar-dd cardWithShadow">
      
      <!--
      <div class="mat-menu-item">
        <mat-icon class="d-flex align-items-center">
          <i-tabler name="user" class="icon-18 d-flex"></i-tabler></mat-icon>
        <span>{{user.email}}</span>
      </div>
      -->
      <div class="p-x-12 m-t-12">
        <a (click)="logout()" mat-stroked-button color="primary" class="w-100">{{ 'BUTTON.LOGOUT' | translate }}</a>
      </div>
    </mat-menu>
  </span>
</mat-toolbar>